import React from 'react';

import 'bootstrap/dist/css/bootstrap.css';
import './pricingoptionheader.styl'

class PricingOptionHeader extends React.Component {
  render() {
    return (
      <div className="pricing-option-header">
        <i className={ 'icon fa fa-4x fa-' + this.props.icon } aria-hidden="true"></i>
        <h3 className="pricing-option-header__title">{ this.props.title }</h3>
        <span className="pricing-option-header__meta">{ this.props.meta }</span>
      </div>
    );
  }
}

export default PricingOptionHeader;



// WEBPACK FOOTER //
// ./src/components/pricingoptions/pricingoption/PricingOptionHeader.js